/* @fflow */
import React from 'react';
import { DataFilesManifestsDownloadContainer,
         EntityTypesDownloadContainer,
        } from 'containers/DownloadContainers';
import { Row } from 'components/UIKit/Flex';
import moment from 'moment';

export default function DataFilesToolbar({
  router: { location: { query }},
  list: {
    data: { items }
  },
  entity
}): React.Element {
  return (
    <Row>
      <EntityTypesDownloadContainer
        customDataTestID="button-download-all"
        entityTypes={[entity]}
        downloadAll
      >
        download all
      </EntityTypesDownloadContainer>
      <DataFilesManifestsDownloadContainer
        downloadAllOfType={entity}
        disabled={ !(items || []).length }
        filename={`manifest_${entity}_${moment().format('YYYYMMDDHHmm')}.yml`}
      >
        All Manifests
      </DataFilesManifestsDownloadContainer>
    </Row>
  );
}
